import Image from 'next/image';
import Link from 'next/link';

const About = () => {
  return (
    <section className="py-20 bg-[#f5f2f0]">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative h-[500px] rounded-[24px] overflow-hidden">
              <Image
                src="/about-image.jpg"
                alt="Two women at gym"
                fill
                className="object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <p className="text-sm font-medium text-[#8a7490] tracking-wide uppercase">
              About Female Fitness Finder
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2b262e] leading-tight">
              Finding the right women only gym or female personal trainer is simple.
            </h2>
            <div className="space-y-4 text-[#6e6672] leading-relaxed">
              <p>
                We believe every woman deserves access to fitness spaces where she feels safe, supported, and empowered. Whether you're new to fitness or looking to level up your routine, we connect you with verified women-only gyms, studios, and female personal trainers in your area.
              </p>
              <p>
                Our platform takes the guesswork out of finding the right fit. Browse detailed listings, read genuine reviews from other women, view photos and amenities, and book classes or consultations directly—all in one place.
              </p>
              <p>
                From yoga and Pilates to strength training and HIIT, discover fitness options designed with women in mind. No more uncomfortable gym environments. Just welcoming spaces where you can focus on your health and wellness journey.
              </p>
            </div>
            <Link
              href="/about"
              className="inline-block px-8 py-3 bg-[#8a7490] text-white font-medium rounded-xl hover:bg-[#7a647d] transition-colors"
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
